import React from "react";
import { Link } from "react-router-dom";

/**
 * Renders a breadcrumb trail under the page title.
 * items: [{ label, to? }] — last item is current (no link).
 */
export default function AdminBreadcrumb({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav className="text-sm text-gray-500 mt-0.5" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && <span className="text-gray-400">/</span>}
              {isLast || !item.to ? (
                <span className={isLast ? "text-gray-700 font-medium" : ""}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="text-blue-600 hover:underline">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
